// extracted by mini-css-extract-plugin
module.exports = {"content":"Popover_content__P6RWU","contentShadow":"Popover_contentShadow__L8uxr"};